import React from "react";

import './style.scss';

import {RadioButton} from './components/radiobutton';

export const RadioQuestion = ({
    theme,
    options,
    componentName,
    answersOnQuestions,
    setAnswersOnQuestions,
}) =>
{
    const classes = ['choice'];

    if (theme !== undefined) {
        classes.push.apply(classes,
            theme.split(' ').map(modifier => `choice-theme-${modifier}`)
        );
    }

    return (
        <div className={classes.join(' ')}>
            {
                options && Array.isArray(options)
                    ? options.map((optionsItem) => (
                            RadioButton({
                                ...optionsItem,
                                componentName,
                                answersOnQuestions,
                                setAnswersOnQuestions
                            })
                        )
                    )
                    : null
            }
        </div>
    )
}
